module.exports = __webpack_public_path__ + "img/logo.d2fcf950.png";